// extracted by mini-css-extract-plugin
module.exports = {"container":"OfferBanner_ketogo_container__kZLko","icon":"OfferBanner_ketogo_icon__3u7YC","link":"OfferBanner_ketogo_link__17gKN"};